// extracted by mini-css-extract-plugin
export default {"action":"style_action__d8sZk","name":"style_name__2GQFf","tags":"style_tags__xP8Lg"};